import React from "react";
import {Component} from "react";
import logo from '../../../component/logo.png';
import main from '../component/banner.png'
import * as apiUtil from "../../../util/apiUtil";
import {aesEncrypt} from "../../../util/aes256";


/**
 * 250513 네이버 DA 이벤트 페이지
 * */
class EventBrandContainer extends Component {
    constructor(props) {
        super(props);

        this.saveAdSrcToStorage = this.saveAdSrcToStorage.bind(this);
        this.ajaxLogAdSrc = this.ajaxLogAdSrc.bind(this);

        this.handleKakaoLogin = this.handleKakaoLogin.bind(this);

        this.state = {};
    }

    componentDidMount() {
        this.ajaxLogAdSrc();
    }

    async ajaxLogAdSrc() {
        const { adSrc } = this.props;
        if (adSrc) {
            this.saveAdSrcToStorage();

            const ip = await apiUtil.getClientIp()
            apiUtil.asyncRequest({
                url: `/api/common/adpath`,
                method: apiUtil.requestMethod.POST,
                header: {
                    'x-forwarded-for': ip
                },
                data: {
                    adSrc: adSrc,
                },
                success: (result) => {}
            })
        }
    }

    saveAdSrcToStorage() {
        const { adSrc } = this.props;
        window.sessionStorage.setItem('adSrc', adSrc);
    }

    handleKakaoLogin() {
        const state = {
            oauthType: 'KAKAO'
        }
        const encodedState = encodeURIComponent(aesEncrypt(JSON.stringify(state)));

        let url = `https://kauth.kakao.com/oauth/authorize`;
        url += `?prompt=select_account`;
        url += `&client_id=${process.env.REACT_APP_SYNC_CLIENT_ID}`;
        url += `&redirect_uri=${process.env.REACT_APP_SYNC_REDIRECT_URI}`;
        url += `&response_type=code`;
        url += `&state=${encodedState}`;

        window.location.href = url;
    }

    render() {
        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', margin: '0', fontFamily: 'Arial, sans-serif', backgroundColor: '#ffffff'}}>
                <div style={{textAlign: 'center', width: '100%', maxWidth: '500px', marginTop: '50px'}}>

                    {/* 최상단 이미지 시작 */}
                    <a href="/" className="symbol_login">
                        <img src={logo} alt="logo.png" style={{width: '130px'}}/>
                    </a>
                    {/* 최상단 이미지 끝 */}

                    <p style={{fontSize: '27px', fontWeight: '500', color: '#525151', marginTop: '20px', lineHeight: '1.3'}}>
                        바이럴을 넘어,<br/>사람과 사람을 잇는<br/>새로운 마케팅, <span style={{color: '#3D3FC9', fontWeight: '600'}}>비즈팅</span>
                    </p>

                    <img src={main} alt="톡이지 프로모션 이미지" style={{width:'100%',maxWidth:'400px',margin:'15px auto',display:'block'}}/>

                    <div style={{
                        background: '#e2d6ef',
                        color: '#4d4850',
                        fontSize: '24px',
                        fontWeight: 'bold',
                        padding: '3px 20px',
                        margin: '15px auto 0',
                        display: 'inline-block',
                        borderRadius: '10px',
                        textAlign: 'center'
                    }}>
                        타겟 광고 메시지
                    </div>

                    <p style={{fontSize: '24px', fontWeight: 'bold', color: '#3D3FC9', marginTop: '18px'}}>
                        첫 충전 시, 1000건 무료
                    </p>

                    <button
                        style={{
                            display: 'block',
                            width: '250px',
                            padding: '12px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: 'white',
                            background: '#3D3FC9',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            margin: '15px auto',
                            textAlign: 'center'
                        }}
                        onClick={this.handleKakaoLogin}
                        onMouseOver={(e) => e.target.style.background = '#2A2DAF'}
                        onMouseOut={(e) => e.target.style.background = '#3D3FC9'}
                    >
                        비즈팅 이용하기
                    </button>

                    <p style={{color: '#9b9b9b', fontSize: '12px', marginTop:'8px'}}>
                    &nbsp;
                    </p>
                </div>
            </div>
        )
    }
}

export default EventBrandContainer;
